export default "__VITE_ASSET__C$SirhEu__"